import {FETCH_CATEGORIES, CLEAN_CATEGORIES, DELETE_CATEGORY, DELETE_CATEGORIES} from '../actions/types';

const CATEGORIES_DEFAULT_STATE = {};

const CategoriesReducer = (state = CATEGORIES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_CATEGORIES:
            return payload;

        case CLEAN_CATEGORIES:
        case DELETE_CATEGORY:
        case DELETE_CATEGORIES:
            return CATEGORIES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default CategoriesReducer;
